/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChainBlockInfo,
    ChainBlockInfoFromJSON,
    ChainBlockInfoFromJSONTyped,
    ChainBlockInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChainBlocksResponse
 */
export interface ChainBlocksResponse {
    /**
     * 
     * @type {Array<ChainBlockInfo>}
     * @memberof ChainBlocksResponse
     */
    list: Array<ChainBlockInfo>;
    /**
     * 
     * @type {number}
     * @memberof ChainBlocksResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainBlocksResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainBlocksResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainBlocksResponse
     */
    totalSize?: number;
}

export function ChainBlocksResponseFromJSON(json: any): ChainBlocksResponse {
    return ChainBlocksResponseFromJSONTyped(json, false);
}

export function ChainBlocksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainBlocksResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ChainBlockInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function ChainBlocksResponseToJSON(value?: ChainBlocksResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ChainBlockInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


